module.exports = __webpack_public_path__ + "a4660f8295436bcb834017f160870d3c.pdf";